import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Modal, Radio, DatePicker, Input, message } from 'hljd'
import { observer } from 'mobx-react'
import moment from 'moment'
import {
  TASK_TYPE_APPO,
  TASK_TYPE_BACK,
  TASK_TYPE_EVENT
} from '@components/JiaMeng/NewCustomer/constant'
import style from '@components/JiaMeng/NewCustomer/style/modal.css'

@Form.create()
@observer
class TaskModal extends Component {
  handleOk = () => {
    const { store, form } = this.props
    const { createTask } = store
    const fieldValue = form.getFieldsValue()

    if (!fieldValue.remind_type) {
      return message.warning('请选择任务类型')
    }

    if (!fieldValue.remark) {
      return message.warning('请输入内容')
    }

    if (!fieldValue.remind_time) {
      return message.warning('请选择日期')
    }

    const value = {
      ...fieldValue
    }
    if (fieldValue.remind_time) {
      value.remind_time = moment(value.remind_time).format(__FMT2__)
    }

    createTask(value)
  }

  render() {
    const { taskModalVisible, setStoreData } = this.props.store
    const { getFieldDecorator } = this.props.form

    return (
      <Modal
        title="创建任务"
        visible={taskModalVisible}
        onOk={this.handleOk}
        onCancel={() =>
          setStoreData([{ type: 'taskModalVisible', value: false }])
        }
        destroyOnClose={true}
        width={410}
        wrapClassName={style.modal}
      >
        <Form className={style.form}>
          <Form.Item label="任务类型">
            {getFieldDecorator('remind_type')(
              <Radio.Group>
                <Radio value={TASK_TYPE_APPO}>预约到店</Radio>
                <Radio value={TASK_TYPE_BACK}>回访提醒</Radio>
                <Radio value={TASK_TYPE_EVENT}>事项提醒</Radio>
              </Radio.Group>
            )}
          </Form.Item>

          <Form.Item label="内容">
            {getFieldDecorator('remark')(<Input.TextArea />)}
          </Form.Item>

          <Form.Item label="提醒时间">
            {getFieldDecorator('remind_time')(
              <DatePicker format={__FMT2__} showTime />
            )}
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}

export default TaskModal
